import { z } from "zod/mini"

const TextConfigSchema = z.object({
	label: z.nullish(z.string()),
	useAsTitle: z.optional(z.boolean()),
	placeholder: z.optional(z.string()),
})

export const TextModelSchema = z.object({
	type: z.literal("Text"),
	fieldset: z.nullish(z.string()),
	config: z.optional(TextConfigSchema),
})

export type TextModel = z.infer<typeof TextModelSchema>
